module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/rack-server/rackfront.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/rack-server/rackfront.png
// module id = 604
// module chunks = 0